<template>
  <div class="d-flex flex-column align-items-center">
    <div
        class="app-container col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3 vue-container">
      <LoadingOverlay class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-3" v-if="this.isLoading"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {mapState, mapMutations} from "vuex";
import {setBrandConfig} from "@/functions/setBrandConfig";
import AddAppToHome from "@/views/components/AddAppToHome";
import {getNetwork} from "@/config";

export default {
  components: {LoadingOverlay, AddAppToHome},
  computed: {
    ...mapState(['isLoading', 'brandConfig', 'user'])
  },
  methods: {
    ...mapMutations(['setShowAddToHomeScreen', 'setDeferredPrompt', 'setProductId']),
    injectTealium() {
      (function (a, b, c, d) {
        a = 'https://tags.tiqcdn.com/utag/vodafone/za-beatthejams/prod/utag.js';
        b = document;
        c = 'script';
        d = b.createElement(c);
        d.src = a;
        d.type = 'text/java' + c;
        d.async = true;
        a = b.getElementsByTagName(c)[0];
        a.parentNode.insertBefore(d, a);
      })();
    },
    setFavicon() {
      console.log(`here`)
      let iconPath = this.brandConfig.brand === "mtn-za-en" ? 'mtn' : 'vodacom';
      let manifest = {
        name: "App name",
        icons: [{
          src: `./img/${iconPath}/icons/android-chrome-192x192.png`,
          sizes: "192x192",
          type: "image/png"
        }, {
          src: `./img/${iconPath}/icons/android-chrome-512x512.png`,
          sizes: "512x512",
          type: "image/png"
        }, {
          src: `./img/${iconPath}/icons/android-chrome-maskable-192x192.png`,
          sizes: "192x192",
          type: "image/png"
        }, {
          src: `./img/${iconPath}/icons/android-chrome-maskable-512x512.png`,
          sizes: "512x512",
          type: "image/png"
        }]
      };
      let content = encodeURIComponent(JSON.stringify(manifest));
      let url = "data:application/manifest+json," + content;
      let element = document.createElement('link');
      element.setAttribute('rel', 'manifest');
      element.setAttribute('href', url);
      document.querySelector('head').appendChild(element);
    },
    setTabName() {
      document.title = this.brandConfig.gameTitle;
    },
    async showHomeScreenPopup() {
      // const showPopup = await TriviaService.showPopup(this.user.Msisdn, this.user.Service, "AddToHomeScreen");
      // if (showPopup.data) this.setShowAddToHomeScreen(true);
      // else this.setShowAddToHomeScreen(false);
    },
    captureEvent() {
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault()
        // Stash the event so it can be triggered later.
        this.setDeferredPrompt(e)
      })
    },
  },
  async beforeMount() {
    setBrandConfig();
    // this.setFavicon()
    this.setTabName();
    await this.showHomeScreenPopup();
    this.captureEvent();
  },
}
</script>

<style>
html, body, #app {
  min-height: 100%;
  background: #000;     /* safety net if anything overflows */
}
body { margin: 0; }
.vue-container {
  position: relative;
  font-family: 'Poppins', sans-serif;
  background-size: cover;
  min-height: 100svh;
  z-index: 0;
  background-color: #000000;
}
.vue-container {
  position: relative;
  font-family: 'Poppins', sans-serif;
  background-color: #000;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100dvh;     /* handles mobile browser UI; see fallback below */
  display: flow-root;     /* prevents margin collapse from last child */
}

/* Fallback for browsers without dvh */
@supports not (min-height: 100dvh) {
  .vue-container { min-height: 100vh; }
}
</style>
